import React from 'react';
import styles from './radio-button.module.scss';

interface RadioButtonProps {
  name?: string;
  value?: string;
  label?: string;
  checked: boolean;
  onChange: () => void;
  className?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({ name, value, checked, onChange, className = '', label }) => {
  return (
    <label className={`${styles.radioButtonLabel} ${className}`}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={styles.hiddenInput}
      />
      <span className={`${styles.customCircle} ${checked && styles.radioButtonSelected}`}></span>
      {label && <span className={styles.radioButtonText}>{label}</span>}
    </label>
  );
};

export default RadioButton;

